import { render, staticRenderFns } from "./field.search.vue?vue&type=template&id=47663fc2&"
import script from "./field.search.vue?vue&type=script&lang=js&"
export * from "./field.search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports